import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef } from "vue";
const _hoisted_1 = { class: "card__inner" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 0,
    class: "marginless"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_5 = { key: 1 };
import { onMounted, reactive } from 'vue';
import API from "@/services/api";
import { ElementDataType, ElementType, FormTypes } from "@/types/FormTypes";
import { setLoadingState } from '@/utils/navigation.util';
import { t } from "@/utils/lang.util";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MailFormCard',
    props: [
        'questionFieldHeight', 'noFocus', 'header', 'autoFocus'
    ],
    setup(__props) {
        const props = __props;
        const formData = {
            apiEndpoint: API.CONTACT_MAIL_FORM,
            submitResult: undefined,
            submitData: {},
            type: FormTypes.EMAIL,
            borderedFields: true,
            elements: [
                {
                    type: ElementType.INPUT_TEXT,
                    dataType: ElementDataType.TEXT,
                    name: '_CONTACT_NAME',
                    minLength: 1,
                    maxLength: 64,
                    required: true,
                    autoFocus: props.autoFocus,
                },
                {
                    type: ElementType.INPUT_TEXT,
                    dataType: ElementDataType.EMAIL,
                    name: '_CONTACT_EMAIL',
                    minLength: 3,
                    maxLength: 320,
                    required: true
                },
                {
                    type: ElementType.SELECT,
                    dataType: ElementDataType.NUMBER,
                    name: 'LABEL',
                    placeholder: t('mailform.fields.TOPIC.placeholder'),
                    label: t('mailform.fields.TOPIC.label'),
                    options: [{ value: 1, text: 'Sales question' }, { value: 2, text: 'Support question' }],
                    defaultValue: 2
                },
                {
                    type: ElementType.TEXTAREA,
                    dataType: ElementDataType.TEXT,
                    name: '_INITIAL_MESSAGE',
                    minLength: 3,
                    required: true,
                    defaultValue: 'Where can I find my order ID?'
                },
                {
                    type: ElementType.FILE_UPLOAD,
                    dataType: ElementDataType.FILE,
                    name: 'FILE_UPLOAD'
                },
                {
                    type: ElementType.SUBMIT_MESSAGE_SLOT
                },
                {
                    type: ElementType.SUBMIT,
                }
            ]
        };
        const form = reactive(formData);
        const formSubmitted = (obj) => {
            form.submitResult = obj.success;
            form.submitData = obj.data;
        };
        onMounted(() => {
            setLoadingState(false);
        });
        return (_ctx, _cache) => {
            const _component_BaseMessage = _resolveComponent("BaseMessage");
            const _component_BaseForm = _resolveComponent("BaseForm");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (form.submitResult === undefined || form.submitResult === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (__props.header)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(__props.header), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('forms.types.EMAIL.description')), 1),
                        _hoisted_4,
                        _createVNode(_component_BaseForm, {
                            modelValue: form,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(form) ? (form).value = $event : null)),
                            endpoint: form.apiEndpoint,
                            onSubmit: formSubmitted,
                            "auto-focus": __props.autoFocus
                        }, {
                            error: _withCtx(() => [
                                _createVNode(_component_BaseMessage, { type: "error" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('forms.types.' + form.type + '.default-error-msg')), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue", "endpoint", "auto-focus"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_BaseMessage, { type: "success" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('forms.types.' + form.type + '.default-success-msg')), 1)
                            ]),
                            _: 1
                        })
                    ]))
            ]));
        };
    }
});
